import { Icon, useT } from "@mmm/ui";
export type ViewMode = "grid" | "list";

interface ViewModeToggleProps {
  value: ViewMode;
  onChange: (value: ViewMode) => void;
}

export function ViewModeToggle({ value, onChange }: ViewModeToggleProps) {
  const t = useT();
  return (
    <div className="mmm-view-toggle" role="group" aria-label={t("common.viewMode")}>
      <button
        type="button"
        className={value === "grid" ? "is-active" : ""}
        aria-label={t("common.gridView")}
        aria-pressed={value === "grid"}
        title={t("common.gridView")}
        onClick={() => onChange("grid")}
      >
        <Icon name="grid" />
      </button>
      <button
        type="button"
        className={value === "list" ? "is-active" : ""}
        aria-label={t("common.listView")}
        aria-pressed={value === "list"}
        title={t("common.listView")}
        onClick={() => onChange("list")}
      >
        <Icon name="list" />
      </button>
    </div>
  );
}
